/* Not exported with the library. You'll want something similar to this for uniquely identifying external hosts in your App */
const MAIL = Symbol("MAIL");
const IDADMIN = Symbol("IDADMIN");

export const apiHosts = {
  MAIL,
  IDADMIN,
};
